import { render, staticRenderFns } from "./ContactUsError.vue?vue&type=template&id=2f438260&"
import script from "./ContactUsError.vue?vue&type=script&lang=js&"
export * from "./ContactUsError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports